<template>
	<transition name="fade" mode="out-in">
		<div :key="$route.path">
			<LandscapeNotice />
			<router-view />
		</div>
	</transition>
</template>

<script>
import LandscapeNotice from "@/components/LandscapeNotice.vue";
export default {
	name: 'App',
	setup() {
		return {
		};
	},
	components: {
		LandscapeNotice,
	}
};
</script>

<style>
.fade-enter-active {
	animation: animate__animated animate__fadeIn 0.5s;
}
.fade-leave-active {
	animation: animate__animated animate__fadeOut 0.5s;
}
</style>